import AuthSubmitButton from './AuthSubmitButton'

export default AuthSubmitButton
